import * as React from 'react';

import AudienceData from '../audience/AudienceData';
import Tooltip from 'components/Tooltip';

import { __t, applyTranslations } from 'utils/language';

import type { InfluencerProfile } from 'types';

type Props = {
  influencerProfile: InfluencerProfile,
  channelUserName: string | undefined | null,
  activeTabMain: string,
  isFreemium: boolean | null | undefined
};

applyTranslations(require('./influencer-audience-data-root.i18n.json'));

class InfluencerAudienceData extends React.PureComponent<Props> {
  render(): React.ReactNode {
    const { channelUserName, activeTabMain } = this.props;

    if (!channelUserName) {
      return null;
    }

    return (
      <div
        className="influencer-audience"
        data-qa="influencer-audience"
      >
        <div className="influencer-audience__title">
          {__t('influencer_audience_data_root.title')}
          <span className="influencer-audience__tooltip">
            <Tooltip
              message={__t(`influencer_audience_data_root.title_tooltip.${activeTabMain}`)}
              showQuestionMark
            />
          </span>
        </div>
        <AudienceData {...this.props} channelType={activeTabMain} />
      </div>
    );
  }
}

export default InfluencerAudienceData;
